<template>
  <div style="display: flex; flex-wrap: wrap" :class="className">
    <span v-if="name" class="scence_ctr_span_title">{{ name }}</span>
    <div class="color-list-box">
      <div
        v-for="(item, index) in model?.UI?.EnumValue"
        :key="index"
        class="color-item"
      >
        <div
          :class="(colorValue || '').toLocaleLowerCase() === (item.Value || '').toLocaleLowerCase() ? 'color-inner checked' : 'color-inner'"
          :style="{ background: `#${item.Value}` }"
          :title="item.Name"
          @click="confirmValue(item.Value)"
        />
        <div class="color-name" :title="item.Name">
          {{ item.Name }}
        </div>
      </div>
      <div class="color-item rgbColorChoose">
        <RgbColorChoose
          need-border
          :color-value="colorValue"
          :model="model"
          @change="confirmValue"
        />
      </div>
      <!-- <div class="color-picker-box-new">
        <div>
          <div v-if="isShowAdd" class="border color-inner">
            +
          </div>
          <div
            v-else
            ref="colorsure"
            :class="[displayedColor ? 'color-inner' : 'border color-inner', isCustom ? 'checked' : '']"
            :style="{ background: `#${colorValue}` }"
            :title="$t('deviceMsg.colorCustomize')"
          >
            <img src="~@/assets/img/cunstom_edit.png" class="cunstom_edit">
          </div>
          <div class="color-name" :title="$t('deviceMsg.colorCustomize')">
            {{ $t('deviceMsg.colorCustomize') }}
          </div>
        </div>
        <div class="color-picker-box">
          <el-color-picker
            class="pick_color"
            :value="`#${colorValue}`"
            :append-to-body="true"
            @change="colorChange"
          />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import { CxCyValueToRGBHex } from '@/utils/colors.js'
// import { rgbToHex } from '@/components/DesignCanvas/utils/common';
import RgbColorChoose from './RgbColorChoose';

export default {
  components: {
    RgbColorChoose
  },
  // directives: { Clickoutside },
  props: {
    isNeedAutoEmit: {
      type: Boolean,
      default: true,
    },
    className: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: true,
    },
    model: {
      type: Object,
      Default: {},
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPanelColor: false,
      colorValue: '',
      maxLength: 127, //0-127坐标值对应128*128的坐标
    }
  },
  computed: {
    // isCustom() {
    //   if (!this.colorValue) return true;

    //   if (!!this.model.EnumValue.find(item => item.Value === this.colorValue)) return false;

    //   return true;
      // if (!this.model || !this.model.EnumValue) {
      //   return false
      // }
      // let hasColor = this.model.EnumValue.filter(item => {
      //   return this.color === item.Value
      // })
      // if (this.model.EnumValue.length > 0 && hasColor.length > 0) {
      //   return false
      // } else {
      //   return true
      // }
    // },
    isShowAdd() {
      if (!this.colorValue) return true;

      // 有颜色 但是不在默认颜色中
      if (!this.model.EnumValue.find(item => item.Value === this.colorValue)) return false;

      return true;
    }
  },
  watch: {
    color() {
      this.initColorValue();
    }
  },

  mounted() {
    this.initColorValue();
  },
  methods: {
    initColorValue() {
      if (this.model.UI?.EnumValueMap && (this.model.EnumValue || []).length === 0) {
        this.model.EnumValue = Object.values(this.model.UI?.EnumValueMap).map(item => ({
          Name: item.remark,
          Value: (item.colorHex || '').substring(1)
        }));
      }
      const color = Number.isInteger(this.color) ? `ffffff` : this.color.replace('#', '');

      this.colorValue = `${(color || '')}`.toLowerCase();
      if (this.isNeedAutoEmit) {
        this.$emit('change', this.colorValue)
      }
    },

    confirmValue(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.color-picker-box-new {
  position: relative;
  z-index: 1002;
}
.color-picker-box {
  position: absolute;
  top: 6px;
  left: 4px;
  z-index: 999;
}

.color-list-box {
  flex: 1;
  .color-inner {
    position: relative;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    z-index: 999;
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #d8d8d8;
    margin: 0 auto;
    background-size: contain !important;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: rotate(-50%, -50%);
    }
  }

  .checked {
    padding: 0;
    border: 3px solid #2589ff;
  }

  .border {
    border: 1px dashed #d8d8d8;
  }

  .color-item {
    margin-right: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .color-name {
    margin-top: 5px;
    // line-height: 20px;
    text-align: center;
    width: 80px;
    font-size: 12px;
    display: block;
    // height: 40px;
    // overflow: hidden;
  }
}

.color-list-box {
  display: flex;
  flex-wrap: wrap;
  //margin-left: -20px;
}
.cunstom_edit {
  position: absolute;
  top: 0px;
  right: -3px;
  width: 23px;
  height: 23px;
}
</style>
<style>
.panel-box-top .el-input__inner {
  padding: 0 0;
  height: 20px !important;
  text-align: center;
}

.panel-box_new {
  background: #fff;
  padding: 5px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.302);
  border-radius: 5px;
}
.panel-box_new .panel-box-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  height: 25px;
}
.panel-box_new .panel-input {
  width: 50px;
  height: 20px;
}

.panel-box_new .color-panel::before {
  display: none;
}
.rgbColorChoose {
  width: 80px;
  display: flex;
  justify-content: center;
}
</style>
